import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { BackendHttpParameterService } from "../../backend-http-parameter.service";

@Injectable({
  providedIn: "root",
})
export class OccupationHttpService {
  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _backendHttpParameterService: BackendHttpParameterService,
  ) {}

  get() {
    const url = environment.backendBaseUrl + "/staticdata/occupations";

    const httpHeaders =
      this._backendHttpParameterService.createDefaultBackendHttpHeaders();

    const response = this._httpClient.get<OccupationResponseDto>(url, {
      headers: httpHeaders,
    });

    return response;
  }
}

export interface OccupationResponseDto {
  occupations: OccupationDto[];
}

export interface OccupationDto {
  occupationId: number;
  labelFemale: string;
  labelMale: string;
}
